export default __webpack_public_path__ + "static/media/logo.296d2a9b.png";